import {
  GET_SHOPS_LIST,
  ERROR_SHOPS,
  GET_SHOP,
  MESSAGE_SHOPS,
  SCROLL_ON_SHOPS,
  EXPORT_SHOPS_LIST,
  SET_SHOPS_FILTERS
} from "../actions/types"

const initialState = {
  shopsList: [],
  shop: {},
  error: {},
  message: {},
  scrollPos: 0,
  filters: {
    search: "",
  },
  exportShopsList: {}
};

export default function shopsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SHOPS_FILTERS:
      return {...state, filters : {...state.filters, ...action.payload }}
    case GET_SHOPS_LIST:
      return {...state, shopsList : action.payload}
    case ERROR_SHOPS:
        return {...state, error: action.payload}
    case GET_SHOP:
      return {...state, shop: action.payload}
    case MESSAGE_SHOPS:
      return {...state, message: action.payload}
    case SCROLL_ON_SHOPS:
      return {...state, scrollPos: action.payload}
    case EXPORT_SHOPS_LIST:
      return {...state, exportShopsList: action.payload}
    default:
      return {...state};
  }
}
